import React, { memo } from 'react';
import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';
import {
  PrintSingleTaskConsumer,
  IPrintSingleTaskContext,
} from 'store/context/PrintSingleTaskContext';

import messages from './Messages';
import { SingleTaskPart } from '../styles';
import { convertDigitToProperFormat } from 'utils/number';
import { IUser } from 'store/users/usersType';

const AssignmentPart: React.FC<
  IPrintPartProps<
    | 'verifiers'
    | 'assignee'
    | 'followers'
    | 'taskPublisher'
    | 'subTaskPublisher'
  >
> = ({ item, taskId, property }) => (
  <PrintSingleTaskConsumer>
    {(dataContext: IPrintSingleTaskContext) => {
      const { members, company, allTasks } = dataContext;
      const {
        part,
        options: { view },
      } = item;

      const showBothKeyValue = view === 'both';
      let showKey = showBothKeyValue;
      let showValue = showBothKeyValue;

      if (!showBothKeyValue) {
        showKey = view === 'key';
        showValue = view === 'value';
      }

      let assignmentTitle;
      let users = {} as { [key: string]: IUser[] };

      if (showKey) {
        const templateId = allTasks?.find(
          (task) => task.id === taskId
        )?.templateId;
        const companyTemplate = company?.templates?.find(
          (template) => template.taskId === templateId
        );
        const whichTitle = (
          part === 'verifiers' ? 'verifierTitle' : `${part}Title`
        ) as
          | 'verifierTitle'
          | 'taskPublisherTitle'
          | 'subTaskPublisherTitle'
          | 'assigneeTitle'
          | 'followersTitle';
        assignmentTitle = messages.getAssignmentTitle(
          part,
          showBothKeyValue,
          companyTemplate?.task?.[whichTitle]
        );
      }

      if (showValue && property) {
        if (Array.isArray(property)) {
          users = (property as any).reduce(
            (current: { [key: string]: IUser[] }, assigneeOrFollower: any) => {
              const user = members?.find(
                (member) => member.id === assigneeOrFollower.userId
              );
              if (user) {
                const group = assigneeOrFollower.properties?.roleName || '';
                if (!current[group]) current[group] = [];
                current[group].push(user);
              }
              return current;
            },
            {} as { [key: string]: IUser[] }
          );
        } else {
          users = {
            [(property as any).properties?.roleName || '']: [
              members?.find(
                (member) => member.id === (property as any) /*WTF*/.userId
              ) as IUser,
            ],
          };
        }
      }
      return (
        <SingleTaskPart>
          <span>{showKey && assignmentTitle}</span>
          <span>
            {showValue &&
              users &&
              (Object.values(users).length > 0
                ? Object.entries(users).map(
                    (userGroup: [string, IUser[]], gIndex) => {
                      const groupName = userGroup[0];
                      const groupContent = userGroup[1];
                      if (groupContent.length < 5 || !groupName)
                        return (
                          <>
                            {gIndex > 0 ? ', ' : ''}
                            <span style={{ display: 'inline' }}>
                              {groupContent.map((user, index) =>
                                messages.getAssignmentName(
                                  user.name,
                                  index + 1 !== groupContent.length
                                )
                              )}
                            </span>
                          </>
                        );
                      return (
                        <>
                          {gIndex > 0 ? ', ' : ''}
                          <details style={{ display: 'inline' }}>
                            <summary style={{ display: 'inline' }}>
                              {convertDigitToProperFormat(groupContent.length) +
                                ' ' +
                                groupName}
                            </summary>
                            <span>
                              {' (' +
                                groupContent.map((user, index) =>
                                  messages.getAssignmentName(
                                    user.name,
                                    index + 1 !== groupContent.length
                                  )
                                ) +
                                ') '}
                            </span>
                          </details>
                        </>
                      );
                    }
                  )
                : messages.fieldIsEmpty)}
          </span>
        </SingleTaskPart>
      );
    }}
  </PrintSingleTaskConsumer>
);

export default memo(AssignmentPart);
